import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

const adminPath = process.env.VUE_APP_ADMIN_PATH;

let loginRoute = {};

// 红星美凯龙登录页面
if (location.host == 'ips.xcmaker.cn') {
    loginRoute = { path: `${adminPath}/login`, name: 'login', component: () => import('./views/Login.vue') };
}
// 通用登录页面
else {
    //  登录
    loginRoute = { path: `${adminPath}/login`, name: 'login', component: () => import('./views/LoginAll.vue') };
}

const router = new Router({
    mode: 'history',
    routes: [
        // xc-ui 列子
        // { path: '/example', name: 'example', component: () => import('./views/example/Index.vue') },
        // { path: '/example/list', name: 'exampleList', component: () => import('./views/example/List.vue') }, // 页面-列表
        // { path: '/example/detail', name: 'exampleDetail', component: () => import('./views/example/Detail.vue') }, // 页面-详情
        // { path: '/example/page', name: 'examplePage', component: () => import('./views/example/Page.vue') }, // 布局-页面
        // { path: '/example/page-full-compose', name: 'examplePageFullCompose', component: () => import('./views/example/PageFullCompose.vue') }, // 布局-整页-组合
        // { path: '/example/page-full-row', name: 'examplePageFullRow', component: () => import('./views/example/PageFullRow.vue') }, // 布局-整页-横向
        // { path: '/example/page-full-col', name: 'examplePageFullCol', component: () => import('./views/example/PageFullCol.vue') }, // 布局-整页-横向
        // { path: '/example/card', name: 'exampleCard', component: () => import('./views/example/Card.vue') }, // 组件-卡片
        // { path: '/example/table', name: 'exampleTable', component: () => import('./views/example/Table.vue') }, // 组件-表格
        // { path: '/example/form', name: 'exampleForm', component: () => import('./views/example/Form.vue') }, // 组件-表单
        // { path: '/example/btn', name: 'exampleBtn', component: () => import('./views/example/Btn.vue') }, // 组件-按钮
        // { path: '/example/btn-select', name: 'exampleBtnSelect', component: () => import('./views/example/BtnSelect.vue') }, // 组件-按钮组/下拉菜单
        // { path: '/example/tree', name: 'exampleTree', component: () => import('./views/example/Tree.vue') }, // 组件-按钮组/下拉菜单
        // { path: '/example/step', name: 'exampleStep', component: () => import('./views/example/Step.vue') }, // 组件-步骤条
        // { path: '/example/modal', name: 'exampleModal', component: () => import('./views/example/Modal.vue') }, // 组件-步骤条
        // { path: '/example/loading', name: 'exampleLoading', component: () => import('./views/example/Loading.vue') }, // 组件-Loading
        // { path: '/example/pagination', name: 'examplePagination', component: () => import('./views/example/Pagination.vue') }, // 组件-分页
        // { path: '/example/upload', name: 'exampleUpload', component: () => import('./views/example/Upload.vue') }, // 组件-上传
        // { path: '/example/myLayer', name: 'exampleMyLayer', component: () => import('./views/example/MyLayer.vue') }, // 组件-layer
        // { path: '/example/flatpickr', name: 'exampleFlatpickr', component: () => import('./views/example/Flatpickr.vue') }, // 组件-flatpickr
        // { path: '/example/layer/page', name: 'exampleLayerPage', component: () => import('./views/example/LayerPage.vue') }, // 组件-flatpickr
        // { path: '/example/city-picker', name: 'exampleCityPicker', component: () => import('./views/example/CityPicker.vue') }, // 组件-flatpickr

        // 当前项目
        { path: `/project`, name: 'index', component: () => import('./views/Project.vue') },

        // 重定向
        { path: '/', redirect: `${adminPath}` },
        { path: '/redirect/:path*', name: 'redirect', component: () => import('./views/Redirect.vue') },

        // 系统首页
        // { path: `${adminPath}`, name: 'index', component: () => import('./views/Index.vue') },


        { ...loginRoute },

        { path: `${adminPath}/reportforms/data`, name: 'reportforms', component: () => import('./views/HomeData.vue') },

        // 后台页面
        {
            path: `${adminPath}`,
            component: () => import('./views/Admin.vue'),
            children: [
                // 统计首页
                { path: "", name: 'home', component: () => import('./views/HomeNew.vue') },

                // 故障管理
                { path: `fault`, name: 'faultManagement', component: () => import('./views/FaultManagement.vue') },  // 故障管理

                // 系统设置
                { path: `system/department`, name: 'departmentList', component: () => import('./views/DepartmentList.vue') }, // 部门列表
                { path: `system/role`, name: 'roleList', component: () => import('./views/RoleList.vue') }, // 角色列表
                { path: `system/set`, name: 'basicSet', component: () => import('./views/SystemSet.vue') }, // 系统设置【基础设置】
                { path: `system/operation`, name: 'operationList', component: () => import('./views/OperationList.vue') }, // 操作日志
                { path: `system/store`, name: 'storeList', component: () => import('./views/StoreList.vue') }, // 门店列表
                { path: `system/user`, name: 'systemUser', component: () => import('./views/SystemUser.vue') }, // 系统用户
                { path: `system/module`, name: 'moduleList', component: () => import('./views/ModuleList.vue') }, // 菜单管理
                { path: `system/user/edit`, name: 'userEdit', component: () => import('./views/UserEdit.vue') }, // 用户编辑
                { path: `system/account/setting`, name: 'accountSetting', component: () => import('./views/AccountSetting.vue') }, //账号设置
                { path: `system/authority-setting`, name: 'authoritySetting', component: () => import('./views/AuthoritySetting.vue') }, // 权限设置（新）
                { path: `system/brand/management`, name: 'brandManagement', component: () => import("./views/BrandManagement.vue") },  // 品牌管理
                { path: `system/knowledge`, name: 'systemKnowledge', component: () => import("./views/systemKnowledge.vue") },  // 知识图谱语音介绍
                { path: `system/items`, name: 'systemItems', component: () => import("./views/systemItems.vue") },  // 项目配置
                { path: `system/house`, name: 'systemHouse', component: () => import("./views/systemHouse.vue") },  // 房间管理
                { path: `system/scenario`, name: 'systemScenario', component: () => import("./views/sceneManage.vue") },  // 场景管理
                { path: `system/composite`, name: 'systemComposite', component: () => import("./views/systemComposite.vue") },  // 组合模式
                


                // 终端管理
                { path: `device`, name: 'deviceList', component: () => import('./views/DeviceList.vue') }, // 终端列表
                { path: `device/apk`, name: 'deviceApkList', component: () => import('./views/DeviceApkList.vue') }, // APK管理
                { path: `device/apk/:deviceUpgradeId/upgrade`, name: 'deviceApkUpgrade', component: () => import('./views/DeviceApkUpgrade.vue') }, // APK升级
                { path: `device/panel`, name: 'devicePanel', component: () => import('./views/devicePanel.vue') }, // 86盒智能面板
                { path: `device/panel/apk`,name: 'devicePanelApk', component: () => import('./views/devicePanelApk.vue') }, // 86盒-APK管理
                { path: `device/apk/:panelApkId/panelUpgrade`, name: 'PanelApkUpgrade', component: () => import('./views/PanelApkUpgrade.vue') }, // 86盒-APK升级

                // 报表统计
                { path: `device/state/statistic`, name: 'deviceStateStatistic', component: () => import('./views/DeviceStateStatistic.vue') }, // 报表统计-在线统计
                { path: `device/state/list`, name: 'deviceStateList', component: () => import('./views/DeviceStateList.vue') }, // 报表统计-设备状态列表
                { path: `device/state/:deviceId/detail`, name: 'deviceStateDetail', component: () => import('./views/DeviceStateDetail.vue') }, // 报表统计-设备状态列表-明细
                { path: `device/play/log`, name: 'devicePlayLog', component: () => import('./views/DevicePlayLog.vue') }, // 报表统计-播放日志


                // 节目管理
                { path: `program`, name: 'programList', component: () => import('./views/ProgramList.vue') }, // 节目列表
                { path: `program/check`, name: 'programCheckList', component: () => import('./views/ProgramCheckList.vue') }, // 节目列表-待审核


                // 素材
                { path: `material/manage`, name: 'materialMng', component: () => import('./views/MaterialMng.vue') }, // 素材库

                { path: `audio`, name: 'audioList', component: () => import('./views/audio/list.vue') }, // 音乐列表
                { path: `audio/check`, name: 'audioCheckList', component: () => import('./views/audio/review.vue') }, // 音乐列表-待审核
                { path: `audio/material`, name: 'audioMaterial', component: () => import('./views/audio/material.vue') }, // 音乐素材库
                { path: `audio/customer`, name: 'audioCustomerMaterial', component: () => import('./views/audio/customerMaterial.vue') }, // 客点音乐素材库
            ]
        },

        { path: `${adminPath}/device/:deviceCode/play`, name: 'devicePlayList', component: () => import('./views/DevicePlayList.vue') }, // 终端播放列表
        { path: `${adminPath}/reportforms/:deviceId/device-statistic`, name: 'homeDeviceStatistic', component: () => import('./views/HomeDeviceStatistic.vue') }, // 今日异常统计

        // 节目管理
        { path: `${adminPath}/program/add`, name: 'programAdd', component: () => import('./views/ProgramAdd.vue') }, // 添加节目-基本信息
        { path: `${adminPath}/program/addAudio`, name: 'addAudio', component: () => import('./views/audio/addAudio.vue') }, // 添加节目-基本信息
        { path: `${adminPath}/program/add/editor`, name: 'programAddEditor', component: () => import('./views/ProgramEditor.vue') }, // 节目JSON编辑器
        { path: `${adminPath}/program/audioEditor`, name: 'audioAddEditor', component: () => import('./views/audioAddEditor.vue') }, // 节目JSON编辑器
        { path: `${adminPath}/program/:programVersion/report`, name: 'programReport', component: () => import('./views/ProgramReport.vue') }, // 统计
        { path: `${adminPath}/program/:programVersion/put-district-list`, name: 'putDistrictList', component: () => import('./views/PutDistrictList.vue') }, // 投放区域
        { path: `${adminPath}/program/:programVersion/push`, name: 'programPush', component: () => import('./views/ProgramPush.vue') }, // 下发详情
        { path: `${adminPath}/program/:programVersion/download`, name: 'programDownload', component: () => import('./views/ProgramDownload.vue') }, // 下载详情
        { path: `${adminPath}/program/:programVersion/log`, name: 'programLog', component: () => import('./views/ProgramLog.vue') }, // 操作日志
        { path: `${adminPath}/program/:programVersion/preview`, name: 'programPreview', component: () => import('./views/ProgramPreview.vue') }, // 节目预览
        { path: `${adminPath}/program/:programVersion/check`, name: 'programCheck', component: () => import('./views/ProgramCheck.vue'), }, // 节目审核
        { path: `${adminPath}/program/:programVersion`, name: 'programEditor', component: () => import('./views/ProgramAdd.vue') }, // 节目编辑
        { path: `${adminPath}/audio/:programVersion`, name: 'audioEditor', component: () => import('./views/audio/addAudio.vue') }, // 音乐编辑
        { path: `${adminPath}/program/:programVersion/select-point`, name: 'selectPoint', component: () => import('./views/SelectPoint.vue') }, // 选点
        { path: `${adminPath}/program/:programVersion/select-point1`, name: 'selectPointAudio', component: () => import('./views/audio/SelectPoint.vue') }, // 选点

        // 终端管理
        { path: `${adminPath}/device/:deviceId/publishProgram`, name: 'devicePublishProgram', component: () => import('./views/DevicePublishProgram.vue') }, // 发布节目
        { path: `${adminPath}/device/:deviceId/increasedPlay`, name: 'deviceIncreasedPlay', component: () => import('./views/DeviceIncreasedPlay.vue') }, // 文件增播
        { path: `${adminPath}/device/:deviceId/reducePlay`, name: 'deviceReducePlay', component: () => import('./views/DeviceReducePlay.vue') }, // 文件减播
        { path: `${adminPath}/device/apk/:deviceUpgradeId/upgrade-detail`, name: 'DeviceUpgradeDetail', component: () => import('./views/DeviceUpgradeDetail.vue') },
        { path: `${adminPath}/device/apk/:panelApkId/panel-detail`, name: 'DevicePanelDetail', component: () => import('./views/DevicePanelDetail.vue') },
        { path: `${adminPath}/device/:deviceCode/detail`, name: 'deviceListDetail', component: () => import('./views/DeviceListDetail.vue') }, // 终端列表详情

        // 报表统计
        { path: `${adminPath}/device/play/:deviceId/onlinelog`, name: 'deviceOnlineLog', component: () => import('./views/DeviceOnlineLog.vue') }, // 报表统计-设备状态列表-上线日志

        // 素材
        { path: `${adminPath}/material/upload/image`, name: 'materialUploadImage', component: () => import('./views/MaterialUploadImage.vue') }, // 图片素材上传
        { path: `${adminPath}/material/upload/video`, name: 'materialUploadVideo', component: () => import('./views/MaterialUploadVideo.vue') }, // 视频素材上传
        { path: `${adminPath}/material/upload/web`, name: 'materialUploadWeb', component: () => import('./views/MaterialUploadWeb.vue') }, // web素材上传
        { path: `${adminPath}/material/upload/audio`, name: 'uploadAudio', component: () => import('./views/audio/uploadAudio.vue') }, // web素材上传
        { path: `${adminPath}/material/preview`, name: 'materialPreview', component: () => import('./views/MaterialPreview.vue') }, // 素材预览
        { path: `${adminPath}/material/select`, name: 'materialSelect', component: () => import('./views/MaterialSelect.vue') }, // 从素材库选择

        // 系统设置
        { path: `${adminPath}/system/device/import`, name: 'deviceImport', component: () => import('./views/DeviceImport.vue') }, // 导入设备
        { path: `${adminPath}/system/department/select`, name: 'departmentSelect', component: () => import('./views/DepartmentSelect.vue') }, // 部门列表(树形）
        { path: `${adminPath}/system/authority-set`, name: 'authoritySet', component: () => import('./views/AuthoritySet.vue') }, // 权限设置
        { path: `${adminPath}/system/map`, name: 'map', component: () => import('./views/Map.vue') }, // 地图
        // { path: `${adminPath}/system/authority-setting`, name: 'authoritySetting', component: () => import('./views/AuthoritySetting.vue') }, // 权限设置（新）

        // 大数据看板
        { path: `${adminPath}/kanban/example`, name: 'kanbanExp', component: () => import('./views/KanbanExample.vue') },
        { path: `${adminPath}/kanban`, name: 'kanban', component: () => import("./views/Kanban.vue") },

        // 路由规范(按模块定义)
        // /demo demo列表
        // /demo/add demo新增
        // /demo/map demo地图
        // /demo/:demoId/preview 详情预览
        // /demo/:demoId demo详情

        // 404
        { path: '*', name: 'NotFound', component: () => import('./views/NotFound.vue') },
    ]
})



// router.beforeEach((to, from, next) => {

//     // 判断用户是否登录
//     if (to.path.indexOf(`${adminPath}`) == 0) {

//         // 过滤验证
//         const excludeUrl = [`${adminPath}/login`];
//         if (excludeUrl.includes(to.path)) return next();

//         const user = store.get('adminUser');
//         if (user) {
//             next();
//         } else {
//             router.replace({
//                 path: `${adminPath}/login`,
//                 query: {
//                     backUrl: encodeURIComponent(to.fullPath),
//                 }
//             })

//             next();
//         }
//     } else {
//         next();
//     }

// })

export default router;
